import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { eliminarAtencionACliente, eliminarUsuarioAtencionACliente, obtenerCarteraConAsociados, obtenerEstadisticas, obtenerUsuariosAtencionACliente } from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'
import { useDispatch, useSelector } from 'react-redux'
import estilos from './UsuariosComponent.module.css'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CredencialComponent from './CredencialComponent'
import { DataGrid } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import Backdrop from '@mui/material/Backdrop';
import AsignacionEjecutivosComponent from './AsignacionEjecutivosComponent'
import Fade from '@mui/material/Fade';
import TablaCarteraComponent from './TablaCarteraComponent'
import Select from 'react-select';
import { actualizarClienteCartera, obtenerClientesAsignar } from '../../../redux/InformacionValidaDucks'
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks'
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1250,
    height: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    'overflowY': 'scroll',
};

const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const styleEjecutivos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: 550,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function UsuariosComponent(props) {

    const dispatch = useDispatch()
    const usuarios = props.usuarios
    const dataCartera = props.dataCartera

    // let dataCartera = useSelector(store => store.UsuariosAtencionACliente.dataCartera)
    let ClientesAsignar = useSelector(store => store.InformacionValidaApi.ClientesAsignar)

    const [openCredencial, setOpenCredencial] = React.useState(false);
    const [dataUser, setDataUser] = React.useState('');
    const handleOpenCredencial = (data) => {
        setDataUser(data)
        setOpenCredencial(true);
    }
    const handleCloseCredencial = () => setOpenCredencial(false);

    const [openCartera, setOpenCartera] = React.useState(false);
    const handleOpenCartera = async (cartera) => {
        await dispatch(obtenerCarteraConAsociados(cartera))
        setOpenCartera(true);
    }
    const handleCloseCartera = () => setOpenCartera(false);


    const [asociadosNoSeleccionados, setAsociadosNoSeleccionados] = React.useState(false)
    const handleOpenAsociadosNoSeleccionados = () => setAsociadosNoSeleccionados(true);
    const handleCloseAsociadosNoSeleccionados = () => setAsociadosNoSeleccionados(false);

    const handleRemoveInspector = async (id) => {
        await dispatch(eliminarUsuarioAtencionACliente(id))
        handleCloseModal()
    }

    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [idUser, setIdUser] = React.useState('')
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setIdUser(data.usuario)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setIdUser('')
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style2}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707" }}>
                            <center><strong>{titleModal}</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'justify' }}>
                            {bodyModal}
                            <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-danger' onClick={() => {
                                switch (accion) {
                                    case 'eliminar':
                                        handleRemoveInspector(idUser)
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    const botonEliminar = async (id) => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de eliminar un usuario, esta acción no se podrá revertir.`,
            accion: 'eliminar',
            usuario: id,
        })
    }

    const rowsEjecutivo = []
    let numUser = 1
    for (const usuario of usuarios) {
        let puestoUser = null
        if (usuario.idrol === 1) puestoUser = 'Jefe de atención a cliente'
        if (usuario.idrol === 2) puestoUser = 'Ejecutivo de Atención a Cliente'
        if (usuario.idrol === 3) puestoUser = 'Recepcionista'
        rowsEjecutivo.push({ num: numUser, id: `${usuario?.datoslogin?.iddatoslogin}`, nombre: usuario?.datoslogin?.nombre + ' ' + usuario?.datoslogin?.apellidos, puesto: puestoUser, nameCartera: usuario?.datoslogin?.cartera?.nombrecartera, dataUser: usuario })
        numUser++
    }

    const columnsEjecutivo = [
        { field: 'num', headerAlign: 'center', headerName: 'N°', width: 70, headerClassName: estilos.headerColumn, align: 'center' },
        { field: 'nombre', headerAlign: 'center', headerName: 'Nombre', width: 300, headerClassName: estilos.headerColumn, },
        { field: 'puesto', headerAlign: 'center', headerName: 'Puesto', width: 225, headerClassName: estilos.headerColumn, },
        { field: 'nameCartera', headerAlign: 'center', headerName: 'Nombre de cartera', width: 190, headerClassName: estilos.headerColumn, },
        {
            field: 'accion', headerAlign: 'center', headerName: 'Acción', width: 110, headerClassName: estilos.headerColumn, align: 'center',
            renderCell: (params) =>
            (
                <div>
                    <button onClick={() => props.onModify(params.row.dataUser)} className={`btn btn-outline-warning btn-sm ${estilos.btnLyricsDark}`}>Modificar</button>
                    {/* <button onClick={() => botonEliminar(params.row.id)} className='btn btn-outline-danger ms-1'>Eliminar</button> */}
                </div>
            )
        },

        {
            field: 'cartera', headerAlign: 'center', headerName: 'Cartera', width: 110, headerClassName: estilos.headerColumn, align: 'center',
            renderCell: (params) =>
            (
                <div>
                    {
                        (params.row.dataUser.idrol === 2 || params.row.dataUser.idrol === 1) &&
                        <button onClick={e => handleOpenCartera(params.row.nameCartera)} className={`btn btn-outline-success btn-sm ${estilos.btnLyricsDark}`}>Consultar</button>
                    }

                </div>
            )
        },
        {
            field: 'estadistica', headerAlign: 'center', headerName: 'Estadistica', width: 110, headerClassName: estilos.headerColumn, align: 'center',
            renderCell: (params) =>
            (
                <div>
                    {
                        (params.row.dataUser.idrol === 2 || params.row.dataUser.idrol === 1) &&
                        <button onClick={() => handleOpenCredencial(params.row.dataUser)} className={`btn btn-outline-success btn-sm ${estilos.btnLyricsDark}`}>Consultar</button>
                    }
                </div>
            )
        },
    ]




    const [rowsAsociado, setRowAsociado] = React.useState([])
    React.useEffect(() => {
        const dataAsociados = []
        for (const i in dataCartera) {
            for (const j in dataCartera[i]?.cliente) {
                dataAsociados.push({ id: dataCartera[i]?.cliente?.[j]?.idcliente, NumeroDeSocio: dataCartera[i]?.cliente?.[j]?.numerosocio, Nombre: dataCartera[i]?.cliente?.[j]?.nombrerazonsocial, seleccioanado: false },)
            }

        }
        setRowAsociado(dataAsociados)
    }, [dataCartera])

    React.useEffect(() => {
        dispatch(obtenerClientesAsignar())
    }, [])
    {/* 
            field: 'cartera', headerAlign: 'center', headerName: '', width: 100,
            renderHeader: (params) =>
            (
                <div>
                    <input className={`${estilos.checkSeleccion}`} type="checkbox" name="" id="" onChange={(e) => selectedChecks(e)} />
                    <input className={`${estilos.checkSeleccion}`} type="checkbox" name="" id="" checked={params.row.seleccioanado} onChange={() => handleSelected(params.id)}/> 
                </div>
            )
        */}
    const columnsAsociado = [

        {
            field: 'cartera', headerAlign: 'center', headerName: '', flex: .2, headerClassName: estilos.headerColumn,
            renderCell: (params) =>
            (
                <div>
                    <input className={`${estilos.checkSeleccion}`} type="checkbox" name="" id="" checked={params.row.seleccioanado} onChange={() => handleSelected(params.id)} />
                </div>
            )
        },
        { field: 'NumeroDeSocio', headerAlign: 'center', headerName: 'Numero De Socio', flex: .3, headerClassName: estilos.headerColumn },
        { field: 'Nombre', headerAlign: 'center', headerName: 'Nombre/Razón social', flex: 1, headerClassName: estilos.headerColumn },
    ]
    const selectedChecks = (e) => {
        if (e.target.checked) {
            rowsAsociado.map(anexo => {
                anexo.seleccioanado = true
            })
        } else {
            rowsAsociado.map(anexo => {
                anexo.seleccioanado = false
            })
        }
    }
    const handleSelected = (id) => {
        rowsAsociado.map(anexo => {
            if (anexo.id === id) anexo.seleccioanado = !anexo.seleccioanado
        })
    }

    let idsParaAsignar = []
    const handleAssign = () => {
    }

    const [openEjecutivos, setOpenEjecutivos] = React.useState(false);
    const [usuariosEjecutivos, setUsuariosEjecutivos] = React.useState(null)
    const [idsAsociados, setIdsAsociados] = React.useState([])

    const handleOpenEjecutivos = () => setOpenEjecutivos(true);
    const handleCloseEjecutivos = () => {
        setUsuariosEjecutivos(null)
        setOpenEjecutivos(false)
    }

    const handleOpenModalRevisores = () => {
        let usersEjecutivos = []
        for (const usuario of usuarios) {
            if (usuario.idrol === 2) usersEjecutivos.push(usuario)
        }

        setUsuariosEjecutivos(usersEjecutivos)

        const asociadosSeleccionados = []
        for (const row of rowsAsociado) {
            if (row.seleccioanado) asociadosSeleccionados.push(row)
        }
        setIdsAsociados(asociadosSeleccionados)
        if (asociadosSeleccionados.length !== 0) {
            handleOpenEjecutivos()
        } else {
            handleOpenAsociadosNoSeleccionados()
        }
    }


    const [selectionModel, setSelectionModel] = React.useState([]);
    const [selectedRows, setSelectedRows] = React.useState([]);







    const [conceptosSeleccionados, setConceptosSeleccionados] = useState([]);

    const formateoServicios = ClientesAsignar?.map(cliente => ({
        value: cliente?.idcliente,
        label: cliente?.numerosocio + ' / ' + cliente?.nombrerazonsocial,
    }));
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            //borderColor: conceptosSeleccionados.length > 0 ? 'green' : 'red',
        }),
    };
    const handleSelectChange = async (selectedOptions) => {
        setConceptosSeleccionados(selectedOptions);
    };

    const [openModalConfirmacion, setOpenModalConfirmacion] = React.useState(false);

    const handleCloseConfirmacion = () => setOpenModalConfirmacion(false);

    const asignarNuevosClientesCartera = async () => {
        await dispatch(actualizarLoadingApp_true())
        let data = { conceptosSeleccionados:conceptosSeleccionados, idcartera: dataCartera?.[0]?.idcartera }
        await dispatch(actualizarClienteCartera(data))
        await dispatch(obtenerCarteraConAsociados(dataCartera?.[0]?.nombrecartera))
        await dispatch(actualizarLoadingApp_false())
        handleCloseCartera()
        handleCloseConfirmacion()
        setConceptosSeleccionados([])
    }
    return (
        <Fragment>
            <div className='row justify-content-center'>
                <div className='col-12 bg-white'>
                    <div style={{ height: 600, width: '100%' }}>
                        <DataGrid
                            rows={rowsEjecutivo}
                            columns={columnsEjecutivo}
                            pageSize={10}
                            getRowId={(row) => row.id}
                            rowsPerPageOptions={[7]}
                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                // '& .MuiDataGrid-cell': {
                                //     display: 'block',
                                //     position: 'relative',
                                //     textAlign: 'center',
                                // },
                            }}
                        />
                    </div>
                </div>
            </div>
            {modalComponent()}

            <Modal
                open={openCredencial}
                onClose={handleCloseCredencial}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <CredencialComponent usuario={dataUser}></CredencialComponent>
                </Box>
            </Modal>


            <Modal
                open={openCartera}
                onClose={handleCloseCartera}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h4" component="h2" align='center'>
                        Asignación de clientes asociados
                    </Typography>
                    <br /><br />
                    <div className='row'>
                        <div className="mb-3 col-10 tex-center">
                            <Select
                                className="react-select mb-3"
                                closeMenuOnSelect={true}
                                required
                                options={formateoServicios}
                                isMulti
                                placeholder='Seleccione un concepto'
                                value={conceptosSeleccionados}
                                onChange={(selectedOptions) => handleSelectChange(selectedOptions)}
                                styles={customStyles}
                            />
                        </div>
                        <div className='col-2'>
                            <button type='button' className='btn btn-outline-success' onClick={() => setOpenModalConfirmacion(true)}>Agregar</button>
                        </div>
                    </div>
                    <TablaCarteraComponent rowsAsociado={rowsAsociado} columnsAsociado={columnsAsociado} />
                    <div className='text-end'>
                        <button type='button' className='btn btn-outline-success' onClick={() => handleOpenModalRevisores()}>Asignar</button>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={asociadosNoSeleccionados}
                onClose={handleCloseAsociadosNoSeleccionados}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style2}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707" }}>
                        <center><strong>Selecciona un asociado para reasignar a una cartera</strong></center>
                    </Typography>
                </Box>
            </Modal>

            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={openEjecutivos}
                    onClose={handleCloseEjecutivos}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={openEjecutivos}>
                        <Box sx={styleEjecutivos}>
                            {
                                usuariosEjecutivos !== null &&
                                <AsignacionEjecutivosComponent usuarios={usuariosEjecutivos} onClose={handleCloseEjecutivos} onCloseCartera={handleCloseCartera} idsAociados={idsAsociados}></AsignacionEjecutivosComponent>
                            }
                        </Box>
                    </Fade>
                </Modal>
            </div>

            <Modal
                open={openModalConfirmacion}
                onClose={handleCloseConfirmacion}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style2}>
                    <Typography id="modal-modal-title" variant="h4" component="h2" align='center'>
                        Mensaje
                    </Typography>
                    <br /><br />
                    <div className='row text-center'>
                        Esta seguro de agregar estos clientes a la cartera {dataCartera?.[0]?.nombrecartera}<br />
                        ¿Desea continuar?
                    </div>
                    <div className='text-end'>
                        <button type='button' className='btn btn-outline-success' onClick={() => asignarNuevosClientesCartera()}>Si estoy seguro</button>
                        <button type='button' className='btn btn-outline-danger' onClick={() => handleCloseConfirmacion()}>No estoy seguro</button>
                    </div>
                </Box>
            </Modal>
        </Fragment>
    );
};

export default withRouter(UsuariosComponent)